export const netWorthCardTitle = 'Total Net Worth';
export const assetsString = 'assets';
export const liabilitiesString = 'liabilities';
export const assetsValueString = '$165,419';
export const liabilitiesValueString = '$65,194';
